import { useState, useEffect } from "react";
import { Authenticated, Unauthenticated, AuthLoading } from "convex/react";
import { Routes, Route } from "react-router-dom";
import { useClerk } from "@clerk/clerk-react";
import Index from "../pages/Index";
import NotFound from "../pages/NotFound";
import { AuthenticationPage } from "./AuthenticationPage";
import { SuperAdminAuthWrapper } from "./SuperAdminAuthWrapper";
import { Button } from "./ui/button";
import { setSelectedDeployment, getSelectedDeploymentId } from "@/config/deployments";

const LoadingScreen = () => {
  const [showSignOut, setShowSignOut] = useState(false);
  const { signOut } = useClerk();
  const currentDeployment = getSelectedDeploymentId();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSignOut(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const handleSignOut = async () => {
    await signOut();
    window.location.reload();
  };

  const handleSwitchToDev = () => {
    setSelectedDeployment("dev");
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Loading...</p>
        {showSignOut && (
          <div className="mt-6 space-y-2">
            <p className="text-sm text-muted-foreground mb-2">Taking too long?</p>
            <Button variant="outline" size="sm" onClick={handleSignOut}>
              Sign Out
            </Button>
            {currentDeployment !== "dev" && (
              <Button variant="ghost" size="sm" onClick={handleSwitchToDev} className="block mx-auto">
                Switch to Development
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export const AuthenticatedApp = () => {
  return (
    <>
      <AuthLoading>
        <LoadingScreen />
      </AuthLoading>
      
      <Unauthenticated>
        <AuthenticationPage />
      </Unauthenticated>
      
      <Authenticated>
        <SuperAdminAuthWrapper>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/section/:sectionId" element={<Index />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </SuperAdminAuthWrapper>
      </Authenticated>
    </>
  );
};